var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"text-left block"},[_vm._t("default")],2),_c('Input',{staticClass:"w-full rounded-md !shadow w-full border-gray-300",attrs:{"type":"time","step":60,"required":_vm.required,"disabled":_vm.disabled},model:{value:(_vm.formValues),callback:function ($$v) {_vm.formValues=$$v},expression:"formValues"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }